import { ClockManualIcon } from "@xola/icons";
import { Badge, Tooltip } from "@xola/ui-kit";
import clsx from "clsx";
import { DateFormat, formatDate } from "common";
import { Dayjs } from "dayjs";
import { isNumber } from "lodash";
import React from "react";
import { Event, User } from "types";
import { NoTranslate } from "../Common/NoTranslate";
import { useResource } from "@/hooks/useResource";
import { getCreatedFromNow } from "@/models/Event";

interface DashboardItemTimeProps {
    dateTime: Dayjs;
    time?: number;
    event?: Event;
}

export const DashboardItemTime = ({ dateTime, time, event }: DashboardItemTimeProps) => {
    const { data: user } = useResource<User>(["users", event?.createdBy]);
    const normalizedTime = isNumber(time) ? formatDate(dateTime, DateFormat.TIME, false) : "All Day";
    const [timePart, meridiem] = normalizedTime.split(" ");

    const manualPopupContent = event?.manual ? getCreatedFromNow("Manually created timeslot", user, event) : "";

    return (
        <div className="ui-time w-9 space-y-1 font-bold leading-p1 tracking-tightest">
            <NoTranslate as="div" data-testid="time-field">
                {timePart}
                <br />
                {meridiem}
            </NoTranslate>

            {event?.manual && (
                <div className="flex justify-center">
                    <Tooltip content={manualPopupContent}>
                        <Badge color="secondary">
                            <ClockManualIcon />
                        </Badge>
                    </Tooltip>
                </div>
            )}
        </div>
    );
};

interface DashboardSearchItemTimeProps {
    dateTime: Dayjs;
    time?: number;
    className?: string;
    showSellerTimezone?: boolean;
}
export const DashboardSearchItemTime = ({
    showSellerTimezone,
    time,
    dateTime,
    className,
    ...rest
}: DashboardSearchItemTimeProps) => {
    const normalizedTime = isNumber(time) ? formatDate(dateTime, DateFormat.TIME, true) : "All Day";

    return (
        <div className={clsx("ui-time", "flex", className)} {...rest}>
            <div className="space-y-1 text-sm font-bold leading-base tracking-tightest">
                <NoTranslate as="div" data-testid="time-date-field">
                    {formatDate(dateTime, DateFormat.DAY_DATE, showSellerTimezone)}
                </NoTranslate>
                <div data-testid="time-field">{normalizedTime}</div>
            </div>
        </div>
    );
};
